module.exports = __webpack_public_path__ + "img/start.5a4ed825.png";